import React from "react";
import CreditCard from "@mui/icons-material/CreditCard";
import Edit from "@mui/icons-material/Edit";
import {
  displayQuickReplyButtonLabel,
  quickReplyIconHint,
} from "../../../utils/customerChatMessageDisplay";

const iconSx = { fontSize: 17, flexShrink: 0, opacity: 0.92 };

/**
 * תווית כפתור quick-reply עם אייקון (עריכה / תשלום) — בלי אימוג'י בטקסט.
 */
export default function CustomerVacationChatQuickReplyLabel({ qr }) {
  const hint = quickReplyIconHint(qr);
  const Icon = hint === "edit" ? Edit : hint === "payment" ? CreditCard : null;
  return (
    <span className="hr-cvac__quick-reply-inner">
      {Icon ? <Icon sx={iconSx} aria-hidden /> : null}
      <span>{displayQuickReplyButtonLabel(qr)}</span>
    </span>
  );
}
